function holdBackNativeToggle(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const summary = target.closest('summary');
  if (!summary) return;

  const details = summary.parentElement;
  if (!(details instanceof HTMLDetailsElement)) return;
  if (!details.classList.contains('menu-drawer-container')) return;

  if (details.hasAttribute('open')) event.preventDefault();
}

document.addEventListener('click', holdBackNativeToggle, { capture: true });
